const enabled = (value) => String(value || "").trim().toLowerCase() === "true";

export const PUBLIC_GUEST_MODE = enabled(process.env.REACT_APP_PUBLIC_GUEST_MODE);

export const storageKeyForMode = (standardKey, guestKey, guestMode = PUBLIC_GUEST_MODE) => (
  guestMode ? guestKey : standardKey
);
